/* dilFormula.js — единен източник на DIL формулата във frontend-а.
 *
 * Mirror на /app/backend/services/dil_formula.py (Nutramilo DIL v2.0).
 * Coefficient 0.69 — independent OLS regression върху n=147 frozen cohort
 * (Holt-Bell-Bao), стабилен спрямо Ridge α∈{1,10} и LASSO α=0.5 (Δ<0.01).
 * Frozen since 2026-02-10.
 *
 * Използване:
 *   import { computeDil } from "@/lib/dilFormula";
 *   const dil = computeDil(protein_g, carbs_g, fiber_g);
 *
 * ВАЖНО: ВИНАГИ ползвайте този хелпър. НЕ копирайте inline
 * `0.69 * protein + max(carbs - fiber, 0)` в нови компоненти —
 * така промяна на коефициента при v3.0 ще се отрази навсякъде.
 */

export const DIL_VERSION = "v2.0";
export const DIL_PROTEIN_COEFF = 0.69;

/** Compute DIL (Dietary Insulin Load) in grams of carb-equivalent.
 *  @param {number} protein Grams of protein
 *  @param {number} carbs   Grams of total carbohydrate
 *  @param {number} fiber   Grams of dietary fiber
 *  @returns {number}       DIL in grams (>= 0)
 */
export function computeDil(protein, carbs, fiber) {
  const p = Math.max(0, Number(protein) || 0);
  const c = Math.max(0, Number(carbs) || 0);
  const fb = Math.max(0, Number(fiber) || 0);
  const netCarbs = Math.max(0, c - fb);
  return Math.max(0, DIL_PROTEIN_COEFF * p + netCarbs);
}

/** Round DIL to one decimal place (display convention across the platform). */
export function computeDilDisplay(protein, carbs, fiber) {
  return Math.round(computeDil(protein, carbs, fiber) * 10) / 10;
}
